<template>
  <div class="detail-padding padding-nav">
    <el-button
      @click="goback"
      type="text"
      class="upper"
      style="margin-bottom: 0.16rem"
      icon="el-icon-d-arrow-left"
      >Go back</el-button
    >
    <div class="spaceBetween" style="margin-bottom: 0.24rem">
      <div class="spaceLeft">
        <div class="detail-title-1">Proposal details</div>
      </div>
    </div>
    <div class="common-card">
      <div class="spaceLeft" style="margin-bottom: 0.3rem">
        <div class="detail_no">No.{{ pageData.id }}</div>
        <el-tooltip  effect="light" placement="top">
          <div slot="content" class="tip_con" >{{pageData.title}}</div>
          <div class="detail_title ellipsis">{{ pageData.title }}</div>
        </el-tooltip>
        <vote-status-comp
          :status.sync="pageData.status"
          :over.sync="pageData.over"
          :cumulative.sync="pageData.vote"
          :threshold.sync="threshold"
        />
      </div>
      <div class="spaceLeft">
        <div style="min-width: 5rem; flex: 1 0 0">
          <div class="detail-item spaceLeft">
            <span class="detail-item-label">Proposer :</span>
            <span class="detail-text-white">
              {{ pageData.proposer }}
            </span>
          </div>
          <div class="detail-item spaceLeft">
            <span class="detail-item-label">Start Block :</span>
            <span class="detail-text-white">
              {{ pageData.startBlock }}
            </span>
          </div>
          <div class="detail-item spaceLeft">
            <span class="detail-item-label">End Block :</span>
            <span class="detail-text-white">
              {{ pageData.endBlock }}
            </span>
          </div>
          <div class="detail-item flexStart" v-if="pageData.discussionUrl">
            <span class="detail-item-label">Discussion :</span>
            <el-tooltip  effect="light" placement="top">
              <div slot="content" class="tip_con" >{{pageData.discussionUrl}}</div>
              <a class="account-url ellipsis" target="_blank" :href="pageData.discussionUrl" >
                {{ pageData.discussionUrl }}
              </a>
            </el-tooltip>
          </div>
        </div>
        <div class="progress_box" style="width: 5rem">
          <vote-progress
            :cumulative.sync="pageData.totalWeight"
            :threshold.sync="pageData.threshold"
          />
          <div class="vote">
            <span class="vote_label">My vote:</span>
            <span class="vote_val">
              <big-number :number="pageData.myVote" />
            </span>
            <span class="vote_unit">UNIT</span>
          </div>
        </div>
      </div>

      <div class="detail-item spaceLeft" style="align-items: flex-start">
        <span class="detail-item-label">Description :</span>
        <div
          class="detail-text-white"
          style="flex: 1"
          v-html="pageData.description"
        ></div>
      </div>
    </div>
    <div class="common-card">
      <div class="detail-title-2 detail-text-white" style="margin-bottom: 0.16rem">
        All Voter
      </div>
      <el-table
        class="common-table"
        :data="tableList"
        v-loading="loading"
        highlight-current-row
      >
        <el-table-column prop="data1" label="" width="50px">
          <template slot-scope="{ $index }">
            {{
              queryParams.total - ((queryParams.page - 1) * queryParams.pageSize + $index)
            }}
          </template>
        </el-table-column>
        <el-table-column prop="voter" label="Voter" show-overflow-tooltip>
          <!-- <template slot-scope="{ row }">
            <account :value.sync="row.voter"/>
          </template> -->
        </el-table-column>
        <el-table-column prop="weight" label="UNIT Vote" align="right">
          <template slot-scope="{ row }">
            <big-number :number="row.weight" />
            <span class="td-word-sm">UNIT</span>
          </template>
        </el-table-column>
        <el-table-column width="200" />
        <el-table-column prop="timestamp" label="Time" align="left">
          <template slot-scope="{ row }">
            {{ moment(row.timestamp).format("YYYY-MM-DD HH:mm:ss") }}
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total.sync="queryParams.total"
        :page.sync="queryParams.page"
        :limit.sync="queryParams.pageSize"
        @pagination="getList()"
      />
    </div>
  </div>
</template>

<script>
import voteStatusComp from "@/views/governance/components/voteStatusComp.vue";
import voteProgress from "@/views/governance/components/voteProgress.vue";
import { daoList, proposalslist } from "@/api/dao.js";
import voteFromTo from "@/views/governance/components/voteFromTo.vue";
export default {
  components: { voteStatusComp, voteProgress, voteFromTo },
  data() {
    return {
      loading: false,
      pageData: {
        status: 1,
      },
      queryParams: {
        total: 0,
        page: 1,
        pageSize: 10,
      },
      tableList: [],
      threshold: undefined,
    };
  },
  computed: {},
  methods: {
    init() {
      this.contractDao = this.$store.getters.contractMap["contractDao"].contract;
      this.contractDaoAdd = this.$store.getters.contractMap["contractDao"].address;
      // this.getThreshold();
      this.getItemList();
      this.getAllVoter();
    },
    getItemList() {
      this.loading = true;
      proposalslist({
        page: 1,
        pageSize: 1,
        proposalId: this.$route.query.proposalId,
        voter: this.$store.getters.metaMaskObj.account,
      })
        .then((res) => {
          let data = res.result ? res.result.list[0] || {} : {};
          this.getThreshold(data).then(() => {
            // 判断 status
            /*if(data.curBlock >= data.endBlock) {
              if (data.totalWeight >= +data.threshold) {
                 data.status = 4;
              }
              else {
                data.status = 2;
              }
          }
          else{
             data.status = 0;
          }*/
            this.pageData = data;
            this.loading = false;
          });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getAllVoter() {
      daoList({
        page: this.queryParams.page,
        pageSize: this.queryParams.pageSize,
        proposalId: this.$route.query.proposalId,
        sortField: "timestamp",
        sequence: "DESC",
      }).then((res) => {
        this.tableList = res.result.data || [];
        this.queryParams.total = res.result.total || 0;
      });
    },
    async getThreshold(row) {
      try {
        row.curBlock = await web3.eth.getBlockNumber();
        row.threshold = await this.contractDao.methods
          .quorum(row.endBlock)
          .call({ from: this.$store.getters.metaMaskObj.account });
        return row;
      } catch (e) {
        console.log(e);
        row.threshold = 0;
        return row;
      }
    },
    // async getAllVoter() {
    //   try {
    //     this.tableList = await this.contractDao.methods["queryVoter"](this.$route.query.number).call({
    //       from: this.$store.getters.metaMaskObj.account
    //     });
    //     console.log(this.tableList)
    //   } catch (e) {
    //     console.log(e);
    //   }
    // },
    getMyVote(list = []) {
      let myVote = 0;
      let accountItem =
        list.find((i) => i.account == this.$store.getters.metaMaskObj.account) || {};
      myVote = accountItem.voteTotal || 0;
      return myVote;
    },
    goback() {
      this.$router.push(this.$route.query.fromPath || "/Governance/pool");
    },
  },
  created() {
    this.init();
  },
  mounted() {},
};
</script>
<style scoped lang="scss">
.detail-padding {
  padding-left: 10%;
  padding-right: 10%;
}
.common-card {
  // background: #FFFFFF;
  border-radius: 0.08rem;
  padding: 0.32rem 0.56rem;
  box-shadow: 0px 12px 28px 0px rgba(6, 16, 32, 0.05);
  margin-bottom: 0.2rem;
}
.detail_no {
  font-size: 0.26rem;
  font-family: HurmeGeometricSans2-Regular, HurmeGeometricSans2;
  font-weight: 400;
  color: #dce0e7;
  line-height: 0.32rem;
  margin-right: 0.1rem;
}
.detail_title {
  font-size: 0.26rem;
  font-family: HurmeGeometricSans2-Regular, HurmeGeometricSans2;
  font-weight: 400;
  color: #ffffff;
  line-height: 0.32rem;
  font-weight: bold;
  max-width: 7rem;
}
.detail-title-2 {
  font-size: 0.2rem;
  color: #ffffff;
}
.detail-item {
  // margin-bottom: 0.32rem;
  margin: 0;
  line-height: 0.56rem;
}
.detail-item-label {
  width: 1.2rem;
  text-align: right;
  color: #ffffff !important;
}
.progress_box {
  position: relative;

  .vote {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 0.2rem;
    font-weight: 500;
    line-height: 0.25rem;
  }
  .vote_label {
    color: #ffffff;
  }
  .vote_val {
    color: #dce0e7;
  }
  .vote_unit {
    font-size: 0.16rem;
    color: #ffffff;
  }
}

.progress_box /deep/ .detail-item-label {
  color: #dce0e7;
}
.progress_box /deep/ .text-num .text-bold {
  color: #ffffff;
}
.account {
  color: #aaaaaa;
  font-size: 0.2rem;
}
.account-url {
  font-size: 0.2rem;
  color: #378efe;
  cursor: pointer;
  flex: 1;
}
.title {
  font-size: 0.28rem;
  font-family: Roboto-Medium, Roboto;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 0.1rem;
}
.detail-text-white {
  color: #dce0e7 !important;
  /deep/ p {
    margin: 0;
    text-align: justify;
    word-break: break-all;
  }
}


</style>
